<template>
  <div id="app" class="App">
    <transition
        @enter="enter" @after-enter="afterEnter"
        @leave="leave" @after-leave="afterLeave"
        @before-enter="beforeEnter"
        :css="false" :mode="mode">>
        <router-view ref="page" v-if="loaded"/>
    </transition>
  </div>
</template>

<script>

import Transition from '@/core/mixins/Transition'

export default {
  name: 'App',
  mixins: [ Transition ],
  data: () => ({
    loaded: false
  }),
  mounted(){
    this.loaded = true
  },
}
</script>

<style lang="stylus"> 

@import '~@/commons/fonts/Fonts'
@import '~@/commons/stylus/Global'


</style>

